import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section id="sobre-mi" className="py-20 bg-white" data-id="element-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a365d] mb-4" data-id="element-13">
            {t('Sobre Mí', 'About Me')}
          </h2>
          <div className="w-24 h-1 bg-[#d97706] mx-auto" data-id="element-14"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex justify-center" data-id="element-16">
            <img src="https://cdn.magicpatterns.com/uploads/dLnjYC7gxuRzsunoHKRasT/ChatGPT_Image_15_mar_2026,_05_25_38_p.m..png" alt="Jesús Silva" className="w-80 h-80 rounded-full object-cover shadow-2xl border-8 border-[#d97706]" data-id="element-17" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-18">
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-19">
              {t('Soy ', 'I am ')}
              <span className="font-semibold text-[#1a365d]" data-id="element-20">Jesús Silva</span>,
              {t(' agente de seguros comprometido con ayudar a personas, familias y adultos mayores a encontrar la protección que realmente necesitan.', ' an insurance agent committed to helping individuals, families, and seniors find the protection they truly need.')}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-21">
              {t('Mi enfoque es personal: escucho tus necesidades, analizo tus opciones y te guío paso a paso para que tomes la mejor decisión con confianza.', 'My approach is personal: I listen to your needs, analyze your options, and guide you step by step so you can make the best decision with confidence.')}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-22">
              {t('Creo que todos merecen acceso a una cobertura de calidad, y mi misión es hacer ese proceso simple y humano.', 'I believe everyone deserves access to quality coverage, and my mission is to make that process simple and human.')}
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}